import { setOrm } from 'common-src/features/orm';
import orm from 'common-src/orm';

import { store } from 'src/store';

import DashboardV2Task from './DashboardV2Task';

export const normalizeDashboardV2Task = (task) => {
  const patient = task.patient || {};
  const phase = task.phase ?? patient.phase ?? null;

  return {
    id: task.id,
    patientId: task.patientId ?? null,
    patient: {
      ...patient,
      phase,
    },
    typeId: task.typeId ?? null,
    reasonId: task.reasonId ?? null,
    createdBy: task.createdBy ?? null,
    departmentAthenaId: task.departmentAthenaId ?? null,
    workflowInstanceId: task.workflowInstanceId ?? null,
    title: task.title,
    taskDescription: task.taskDescription ?? null,
    assessmentType: task.assessmentType ?? null,
    assessmentVariant: task.assessmentVariant ?? null,
    caregiverAssisted: task.caregiverAssisted ?? false,
    caption: task.caption ?? null,
    status: task.status,
    priority: task.priority,
    team: task.team,
    owner: task.owner,
    role: task.role ?? null,
    pathway: task.pathway ?? null,
    phase,
    protocol: task.protocol,
    mustHave2026: task.mustHave2026 ?? false,
    due: task.due,
    taskAssignDueAt: task.taskAssignDueAt ?? task.task_assign_due_at ?? null,
    noteUrl: task.noteUrl ?? null,
    taskSop: task.taskSop ?? null,
    threadId: task.threadId ?? null,
    isRead: task.isRead ?? false,
    externalObjectType: task.externalObjectType ?? null,
    externalObjectId: task.externalObjectId ?? null,
    parentTaskId: task.parentTaskId ?? null,
    isSubtask: task.isSubtask ?? task.is_subtask ?? Boolean(task.parentTaskId),
    evidence: task.evidence ?? null,
    callbackStatus: task.callbackStatus ?? null,
    blockedBy: task.blockedBy ?? null,
    blockedAt: task.blockedAt ?? null,
    blockedStatus: task.blockedStatus ?? null,
    blockedReason: task.blockedReason ?? null,
    escalatedBy: task.escalatedBy ?? null,
    escalatedAt: task.escalatedAt ?? null,
    escalatedStatus: task.escalatedStatus ?? null,
    escalatedTo: task.escalatedTo ?? null,
    escalatedToUser: task.escalatedToUser ?? null,
    unblockedBy: task.unblockedBy ?? null,
    unblockedAt: task.unblockedAt ?? null,
    deescalatedBy: task.deescalatedBy ?? null,
    deescalatedAt: task.deescalatedAt ?? null,
    escalatedReason: task.escalatedReason ?? null,
    isVisible: task.isVisible ?? true,
    stateName: task.stateName ?? null,
    dependency: task.dependency ?? null,
    isFollowing: task.isFollowing ?? false,
    followedBy: task.followedBy ?? [],
  };
};

export const upsertDashboardV2Task = (task) => {
  if (!task?.id) return;

  const rootOrm = store.getState().orm;
  const session = orm.session(rootOrm);
  const modelClass = session[DashboardV2Task.modelName];

  modelClass.upsert(normalizeDashboardV2Task(task));
  store.dispatch(setOrm(session.state));
};

export const syncDashboardV2TaskQueue = (responseBody) => {
  const tasks = responseBody?.data || [];
  const rootOrm = store.getState().orm;
  const session = orm.session(rootOrm);
  const modelClass = session[DashboardV2Task.modelName];

  modelClass.all().delete();
  tasks.forEach((task) => {
    modelClass.upsert(normalizeDashboardV2Task(task));
  });

  store.dispatch(setOrm(session.state));
};
